export const URL = 'http://rhino-api-prod.rys6pfmxbp.us-east-1.elasticbeanstalk.com/v1';
export const HEADERS = {
	'Accept': 'application/json',
	'Content-Type': 'application/json'
};
export const FILE_HEADERS = {
	'Accept': 'application/json'
};
export const STREAMING_URL = 'http://ec2-35-174-114-147.compute-1.amazonaws.com:3000/videos';


// WEBPACK FOOTER //
// ./src/constants/api.prod